import MDBox from "components/MDBox"
import MDButton from "components/MDButton";
import TableSkeleton from "components/TableSkeleton";
import { useEffect, useMemo, useState } from "react"
import { useMaterialUIController, setLoading } from "context";
import { useForm } from "react-hook-form";
import DataTable from "examples/Tables/DataTable";
import permissions from "permissions";
import { CircularProgress } from "@mui/material";
import { EpMasterAPI } from "api/EpMasterAPI";


export default function EpMasterTable(props) {

  const [epMaster, setEpMaster] = useState([]);
  const [controller, dispatch] = useMaterialUIController();
  const { user, loading, admin } = controller;
  const { handleSubmit, formState: { isSubmitting } } = useForm();
  const { handleAlert } = props

  const currencyformatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
  });

  const numberFormater = new Intl.NumberFormat();

  const renderEpMaster = useMemo(() => {
    let rows = [];
    const columns = [
      { Header: "Código PT", accessor: "codigo_pt", align: "right" },
      { Header: "Código MP", accessor: "codigo_mp", align: "right" },
      { Header: "Cantidad", accessor: "cantidad", align: "right", },
      { Header: "Código PP", accessor: "codigo_pp", align: "right" },
      { Header: "Cantidad PP", accessor: "cantidad_pp", align: "right", },
      { Header: "Descripción", accessor: "descripcion", align: "left", },
      { Header: "Proceso", accessor: "proceso", align: "left", },
      { Header: "Nombre Proceso", accessor: "nombre_proceso", align: "left", },
      { Header: "Linea", accessor: "linea", align: "left", },
      { Header: "Nombre Linea", accessor: "nombre_linea", align: "left", },
    ];

    epMaster?.map((element) => {
      rows = [...rows,
      {
        codigo_pt: element.codigo_pt,
        codigo_mp: element.codigo_mp,
        cantidad: element.cantidad,
        codigo_pp: element.codigo_pp,
        cantidad_pp: element.cantidad_pp,
        descripcion: element.descripcion,
        proceso: element.proceso,
        nombre_proceso: element.nombre_proceso,
        linea: element.linea,
        nombre_linea: element.nombre_linea,
      }]
    });

    return (<DataTable
      table={{ columns, rows }}
      isSorted={true}
      entriesPerPage={true}
      showTotalEntries={true}
      noEndBorder
      canSearch={true}
    />
    );
  }, [epMaster])


  const getEpMaster = () => {
    setLoading(dispatch, true)
    return EpMasterAPI.index(true)
      .then(response => {
        setEpMaster(response.ep_master)
      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
        }
      }).finally(() => {
        setLoading(dispatch, false)
      });
  }


  return (
    <MDBox>
      <MDBox sx={{ display: 'flex', flexDirection: 'row-reverse', p: 3 }} component="form" role="form" onSubmit={handleSubmit(getEpMaster)}>
        {(user?.permissions?.includes(permissions.product_arrays[1]) || user?.role === admin) && (
          <MDButton type="submit" variant="gradient" color="info" disabled={isSubmitting}>
            {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Consultar Maestro EP'}
          </MDButton>
        )}
      </MDBox>
      <MDBox>
        {loading ? <TableSkeleton></TableSkeleton> : renderEpMaster}
      </MDBox>
    </MDBox>
  )

}